import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Navigate } from "react-router-dom";
import { Row, Col, FormGroup, Input, Button, Label, Modal, ModalHeader, ModalBody, Card, CardBody } from "reactstrap";
import Services from "./services.js";
import AuthService from "../Authentication/auth.service.js";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import Alerts from "../../components/Alerts/alerts.js";
import PermissionAccess from '../../PermissionAccess/Access.js';

const AddCustomer = ({ onSuccess }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [Customers, setCustomers] = useState([
    {
      name: '',
      email: '',
      phone: '',
      Address: '',
    }]);
  const [loading, setLoading] = useState(false);
  const [loginNavigate, setLoginNavigate] = useState(false);
  const [Fetched_Businesses, setFetched_Businesses] = useState([]);
  const { authData } = PermissionAccess();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  const modalRef = useRef(null);



  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    Fetch_Businesses();
  }, []);


  useEffect(() => {
    if (modalOpen) {
      loadGoogleMapsScript();
    }
  }, [modalOpen]);


  const loadGoogleMapsScript = () => {
    if (!window.google || !window.google.maps) {
      //iph todo: 47
      //console.log("Loading Google Maps script...");
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDlKtLygdyr4XpjVE1WcyR7yHuigyq_agw&libraries=places`;
      script.async = true;
      script.onload = () => {
        //iph todo: 47
        //console.log("Google Maps script loaded. Initializing Autocomplete...");
        initAutocomplete();
      };
      document.head.appendChild(script);
    } else {
      //iph todo: 47
      //console.log("Google Maps already loaded. Initializing Autocomplete...");
      initAutocomplete();
    }
  };

  const initAutocomplete = () => {
    if (!inputRef.current) {
      //iph todo: 47
      //console.log("Input ref not available. Autocomplete initialization delayed.");
      setTimeout(initAutocomplete, 100);
      return;
    }

    //iph todo: 47
    //console.log("Initializing Autocomplete...");
    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['address'],
    });

    autocompleteRef.current.addListener('place_changed', handlePlaceSelect);

    // Adjust the position of the autocomplete dropdown
    const pacContainer = document.querySelector('.pac-container');
    if (pacContainer) {
      pacContainer.style.zIndex = "1500"; // Ensure it's above the modal
      pacContainer.style.width = `${inputRef.current.offsetWidth}px`;
      pacContainer.style.left = `${inputRef.current.getBoundingClientRect().left}px`;
      pacContainer.style.top = `${inputRef.current.getBoundingClientRect().bottom}px`;
    }

    //iph todo: 47
    //console.log("Autocomplete initialized.");

    // Prevent form submission on enter
    inputRef.current.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') e.preventDefault();
    });
  };


  const handlePlaceSelect = () => {
    //iph todo: 47
    //console.log("Place selected. Updating address...");
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) {
      //iph todo: 47
      //console.error('No details available for input:', place.name);
      return;
    }

    const address = place.formatted_address;
    setCustomers(prevCustomers => prevCustomers.map((Customer, i) =>
      i === 0 ? { ...Customer, Address: address } : Customer
    ));
    //iph todo: 47
    //console.log("Address updated:", address);
  };


  function Fetch_Businesses() {
    setLoading(true);
    Services.GetBusinesses(authData.sessionID).then(
      (response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          const business = response.data.data[0];
          setFetched_Businesses([business]);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
      }
    );
  }



  const toggle = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      setCustomers([{
        name: '',
        email: '',
        phone: '',
        Address: '',
      }]);
    }
  };


  const handleCustomerChange = (index, field, value) => {
    setCustomers(prevCustomers => prevCustomers.map((Customer, i) =>
      i === index ? { ...Customer, [field]: value } : Customer
    ));
  };

  const validateForm = () => {
    return Customers.every(Customer =>
      Customer.name &&
      Customer.email &&
      Customer.phone &&
      Customer.Address
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      Alerts.swalErrorAlert("Please fill all fields and upload at least one document for Customers.");
      return;
    }

    // const formData = new FormData();
    let payload = {
      ...Customers[0],
      business_id: Fetched_Businesses[0]._id,
      user_type_id: '6576b4b4e66749ea4ce13108',
      user_type: 'customers',
      status: 'Active',

    }

    setLoading(true);
    try {
      const response = await Services.AddCustomer(authData.sessionID, payload);
      setLoading(false);
      if (response.data.status) {
        onSuccess();
        Alerts.swalSuccessAlert(response.data.message || "Customer Added Successfully.").then(() => {
          toggle();
        });
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          setLoginNavigate(true);
        } else {
          Alerts.swalErrorAlert(response.data.message || "Error: Can't Add Customer at the moment. Please try again later.");
        }
      }
    } catch (error) {
      setLoading(false);
      Alerts.swalErrorAlert("Network Operation failed.");
    }
  };

  if (loginNavigate) {
    return <Navigate to={'/login'} />;
  }

  return (
    <span className="d-inline-block float-end mb-2 me-2">
      <Button color="success" onClick={toggle} className="btn-hover-shine ms-1">
        {t("Add New")}
      </Button>
      <Modal size='lg' isOpen={modalOpen} toggle={toggle} backdrop={true} ref={modalRef}>
        <LoadingOverlay active={loading} spinner={<DNALoader />}>
          <ModalHeader>{t("Add Customer")}</ModalHeader>
          <ModalBody>
            <Card className="main-card mb-3">
              <CardBody>
                <form onSubmit={handleSubmit}>
                  {Customers.map((Customer, index) => (
                    <FormGroup key={index} className="mb-3">
                      <Row>
                        <Col md="6">
                          <Label>{t("Customer Name")}</Label>
                          <Input
                            type="text"
                            value={Customer.name}
                            onChange={(e) => handleCustomerChange(index, 'name', e.target.value)}
                            placeholder={t("Enter Customer Name")}
                          />
                        </Col>
                        <Col md="6">
                          <Label>{t("Email")}</Label>
                          <Input
                            type="email"
                            value={Customer.email}
                            onChange={(e) => handleCustomerChange(index, 'email', e.target.value)}
                            placeholder={t("Enter Email")}
                          />
                        </Col>
                      </Row>
                      <Row style={{marginTop: '10px'}}>
                        <Col md="6">
                          <Label>{t("Phone")}</Label>
                          <Input
                            type="tel"
                            value={Customer.phone}
                            onChange={(e) => handleCustomerChange(index, 'phone', e.target.value)}
                            placeholder={t("Enter Phone Number")}
                          />
                        </Col>
                        <Col md="6">
                          <Label>{t("Address (Google Location)")}</Label>
                          <div style={{ position: 'relative' }}>
                            <Input
                              type="text"
                              value={Customer.Address}
                              onChange={(e) => handleCustomerChange(index, 'Address', e.target.value)}
                              placeholder={t("Enter Address")}
                              innerRef={inputRef}
                            />
                          </div>
                        </Col>
                      </Row>

                    </FormGroup>
                  ))}
                  <div className="text-center">
                    <Button type="submit" color="success" size="lg" className="me-3">
                      {t("Save")}
                    </Button>
                    <Button type="button" color="secondary" size="lg" onClick={toggle}>
                      {t("Cancel")}
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </ModalBody>
        </LoadingOverlay>
      </Modal>
      <style>{`
        .pac-container {
          z-index: 1500 !important;
        }
      `}</style>
    </span>
  );
};

export default AddCustomer;